import {usePreviewContext} from "../../context/PreviewContext";
import {metaDataElementWithId} from "./previewMetaData";
import React, {useEffect} from "react"

interface Props {
    propertyId?: string,
    children: any
}

function PreviewElementBoxDrawer(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const [isMounted, setIsMounted] = React.useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) {
        return <React.Fragment key={props.propertyId}>{props.children}</React.Fragment>
    }

    if (isPreview && props.propertyId) {
        return (<span {...metaDataElementWithId(isPreview, props.propertyId)}>{props.children}</span>)
    } else {
        return <React.Fragment key={props.propertyId}>{props.children}</React.Fragment>
    }
}

export default PreviewElementBoxDrawer;